import { ICommand } from "Application";
import { Button } from "Components";
import { CloseIcon } from "Styles/ThemedPrimitives/Style1/CloseIcon";
import React from "react";
import { observer } from "mobx-react-lite";
import { Container, Footer, ButtonGroup, StyledDialog, Header, ModelBody } from "./OverTimeConfirmationPopup.styles";

export interface IProps {
    closeCommand: ICommand;
    proceedCommand: ICommand;
}

const OverTimeConfirmationPopup: React.FC<IProps> = observer(({ closeCommand, proceedCommand }: IProps) => {
    return (
        <>
            <StyledDialog open={true}>
                <Header>
                    Overtime session confirmation
                    <CloseIcon onClick={() => closeCommand.execute()} />
                </Header>
                <Container>
                    <ModelBody>
                        <span>This slot is outside of the mentor's typical hours.</span>
                        <span>Are you sure you want to proceed?</span>
                    </ModelBody>
                    <Footer>
                        <ButtonGroup>
                            <Button command={proceedCommand} displayName={"Proceed"} paletteColor="primary" />
                            <Button command={closeCommand} displayName={"Cancel"} paletteColor="secondary" />
                        </ButtonGroup>
                    </Footer>
                </Container>
            </StyledDialog>
        </>
    );
});

export default OverTimeConfirmationPopup;
